<template>
  <div class="main_box">
    <div class="body_title flex_layout_between">
      <h2>{{ $t('enum.scheduled') }}</h2>
      <div class="input_blue">
        <el-input :placeholder="$t('enum.searchForItems')" v-model="searchKey" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="getData()"></el-button>
        </el-input>
      </div>
    </div>

    <div class="main_tabs_box">
      <ul class="main_tabs">
        <li @click="changeByWay(2)" :class="byWay == 2 ? 'on' : ''">{{ $t('enum.auction') }}</li>
        <li @click="changeByWay(1)" :class="byWay == 1 ? 'on' : ''">{{ $t('enum.buyItNow') }}</li>
      </ul>
      <div class="main_total">{{ Count }} {{ Count != 1 ? $t('enum.items') : $t('enum.item') }}</div>
    </div>
    <table-check :list="List" showType="scheduled" :byWay="byWay == 2 ? 'Auction' : 'BuyItNow'" v-loading="loading" :loading="loading" />
    <list-pagination v-show="Count > 0" ref="Pagination" :total="Count" @getData="getData" />
  </div>
</template>

<script>
import TableCheck from '@/components/tablecheck'
import ListPagination from '@/components/listpagination'
export default {
  name: '',
  components: { TableCheck, ListPagination },
  data() {
    return {
      loading: true, //page loading
      msgTabs: 0,
      UserInfo: this.$store.state.UserInfo,
      List: [],
      Count: 0,
      searchKey: '',
      PageIndex: 1,
      PageSize: 60,
      byWay: 2,//2=拍卖,1=一口价
      listType: 2,//1=已上架，2=即将上架，3=已下架 Unsold：listType=3，Scheduled：listType=2
      sortType: 6,//1=最快结束时间，2=价格（高-低），3=价格（低-高），4=最新发布，5出价次数（高-低）
      isSort: 1,
    }
  },
  created: function () {
    var that = this;
  },
  mounted: function () {
    var that = this;
    that.byWay = that.$route.params.byWay || 2;
    that.getData();
  },
  methods: {
    // 获取我的 商品列表
    getData(PageIndex, PageSize) {
      var that = this;
      if (PageIndex && PageSize) { that.PageIndex = PageIndex; that.PageSize = PageSize; }
      let _searchKey = encodeURIComponent(that.searchKey);
      let params = `?pageIndex=${that.PageIndex}&pageSize=${that.PageSize}&searchKey=${that.searchKey}&byWay=${that.byWay}&listType=${that.listType}&sortType=${that.sortType}`;
      that.loading = true;
      that.List = [];
      that.Count = 0;
      let fun = function (res) {
        that.loading = false;
        console.log(res)
        if (res.result) {
          var _data = res.data
          that.List = _data;
          that.Count = res.count;
        }
      };
      that.$get('SearchMyCommodities', params)//我的商品列表
        .then((res) => {
          console.log("axios-res:", res);
          fun(res);
        })
        .catch((err) => {
          console.log(err);
          that.loading = false;
        });
    },
    // 获取对应类型的我的商品列表
    changeByWay(val) {
      let that = this;
      that.byWay = val;
      // 切换Scheduled 的tab类型
      that.PageIndex = 1;
      if (that.$refs.Pagination) {
        that.$refs.Pagination.PageIndex = 1;
      }
      console.log(val)
      that.getData();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main_total {
  position: absolute;
  right: 12px;
  top: 22px;
}
</style>



// WEBPACK FOOTER //
// src/pages/commodity/scheduled.vue